<div [formGroup]="control" id="phone-field-{{config.property}}">
  <input type="tel" [value]="config.default" [formControlName]="config.property" (change)="validateAndPatchValue($event)" [className]="!valid || hasErrors
  ? 'error' : ''" (blur)="isBlurred=true;validateAndPatchValue($event)" (focus)="isBlurred=false"/>
</div>
<app-field-error [config]="config" (validityChanged)="validityChanged($event)"></app-field-error>
